import React from 'react';

import ScoringStandings from './scoring-standings';
import { groupKey, usesPointSystem, type ScoringGroup } from './scoring-types';

interface Props {
  groups: ScoringGroup[];
  title: string;
  skipKey?: string | null;
  onOpenGroup?: (group: ScoringGroup) => void;
}

export const ScoringRoundStandings: React.FC<Props> = ({
  groups,
  title,
  skipKey = null,
  onOpenGroup,
}) => {
  const scored = groups.filter(
    (group) => group.standings.length > 0 && groupKey(group) !== skipKey,
  );

  if (scored.length === 0) {
    return null;
  }

  return (
    <section className="scoring-round-standings" data-testid="scoring-round-standings">
      <h2 className="scoring-round-standings__title">{title}</h2>
      <p className="scoring-hint">
        Na żywo z wpisanych wyników — „Klas." to punkty do klasyfikacji za miejsce w grupie
        (1. w pierwszej grupie = 300, każde kolejne −10).
      </p>

      {scored.map((group) => (
        <div className="scoring-round-standings__group" key={groupKey(group)}>
          {group.name !== null && (
            <div className="scoring-round-standings__group-head">
              <h3 className="scoring-round-standings__group-name">Grupa {group.name}</h3>
              {onOpenGroup && (
                <button
                  type="button"
                  className="scoring-round-standings__open"
                  data-testid={`scoring-standings-open-${groupKey(group)}`}
                  onClick={() => onOpenGroup(group)}
                >
                  Otwórz grupę →
                </button>
              )}
            </div>
          )}
          <ScoringStandings
            rows={group.standings}
            showPoints={usesPointSystem(group)}
            testId={`scoring-standings-${groupKey(group)}`}
          />
        </div>
      ))}
    </section>
  );
};

export default ScoringRoundStandings;
